module.exports = __webpack_public_path__ + "static/media/Login_HN_Advice.00a0c73a.png";